import makeService from './api';

export default makeService('design_files');
